import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class JobsService {
    /**
     * Subscribe to action job event stream
     * @param companyId
     * @returns any
     * @throws ApiError
     */
    static jobsActionJobSse(companyId) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/jobs/actionJob/{companyId}',
            path: {
                'companyId': companyId,
            },
        });
    }
    /**
     * Subscribe to rewrite job event stream
     * @param companyId
     * @returns any
     * @throws ApiError
     */
    static jobsRewriteJobSse(companyId) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/jobs/rewriteJob/{companyId}',
            path: {
                'companyId': companyId,
            },
        });
    }
}
